import CookieStorage from '../StorageTargets/CookieStorage';
import PermanentStorage from '../StorageTargets/LocalStorage';
import TemporaryStorage from '../StorageTargets/SessionStorage';

export interface StorageInterface {
  /**
   * @param {string} key Key for store the data and get the data later
   * @param {string} value Data to be stored
   */
  store: (key: string, value: StorageDataType) => void;

  /**
   * It returns the data associated with the key.
   * @param {string} key Key for retrieving the data.
   */
  retrieve: (key: string) => string;

  /**
   * It removes the data associated with the key provided.
   * @param {string} key Key for removing the data associated with.
   */
  remove: (key: string) => void;

  /**
   * To clear all the data available in storage.
   */
  clearStorage: () => void;
}

export const enum StorageType {
  PERMANENT = 'localstorage',
  TEMPORARY = 'sessionstorage',
  COOKIE = 'cookie',
}

export type StorageDataType = string | number | boolean | object;

interface StorageOptions {
  encryption?: boolean;
}

export interface StorageConfigInterface {
  [StorageType.PERMANENT]?: StorageOptions;
  [StorageType.TEMPORARY]?: StorageOptions;
  [StorageType.COOKIE]?: StorageOptions;
}

export type StorageContextProps = {
  configurations: StorageConfigInterface;
  children?: React.ReactNode;
};

export interface StorageInstancesInterface {
  [StorageType.PERMANENT]?: PermanentStorage;
  [StorageType.TEMPORARY]?: TemporaryStorage;
  [StorageType.COOKIE]?: CookieStorage;
}

export interface StorageServiceInterface {
  getStorage: (storageType: StorageType) => StorageInterface;
  getLocalStorage: () => StorageInterface;
  getSessionStorage: () => StorageInterface;
  getCookieStorage: () => StorageInterface;
  setConfig: (configurations: StorageConfigInterface) => void;
}

declare global {
  // eslint-disable-next-line
  var storageService: StorageServiceInterface;
  interface Window {
    storageService: StorageServiceInterface;
  }
}
